<div class="toolbar set-flex-res">
    <div class="title-side accent">
        <h3 class="toolbar-title">{{ 'PAGE.PURCHASE.TITLE' | translate }}</h3>
        <small class="set-font-size">{{ 'PAGE.PURCHASE.DESCRIPTION' | translate }}</small>
    </div>
    <!-- <app-order-category-group></app-order-category-group> -->
</div>
<div class="mg-divider">
  <mat-divider></mat-divider>
</div>
<div class="content">
    <h3 class="title accent set-res-font-size">{{ 'PAGE.PURCHASE.HOME.SEL_TO_PUR' | translate }}</h3>
    <div class="purchase-items">
        <div class="purchase-item" *ngFor="let item of passOfPurchase; let number=index">
            <app-purchase-item-card [item]="item" [index]="number"> </app-purchase-item-card>
        </div>
    </div>
</div>
